import { Component, OnInit } from '@angular/core';
import { Observable, first, Subscription } from 'rxjs';

import { TenantService } from '../../core/services/tenant.service';

import { TenantStatisticsModel } from '../../core/models/tenant.model';
import { ToastService } from '../../../_shared/core/services/toast.service';
import { LoggerCommonService } from 'src/app/_shared/core/services/logger-common.service';

@Component({
  selector: 'sc-tenant-statistics',
  templateUrl: './tenant-statistics.component.html',
  styleUrls: ['./tenant-statistics.component.scss']
})
export class TenantStatisticsComponent implements OnInit {

  isTenantStatisticsLoading$: Observable<boolean>;

  statistics: TenantStatisticsModel;
  statisticItems: any[];

  private unsubscribe: Subscription[] = [];

  constructor(
    private tenantService: TenantService,
    private readonly toastService: ToastService,
    private readonly logger: LoggerCommonService
  ) {
    this.isTenantStatisticsLoading$ = this.tenantService.isTenantStatisticsLoading$;
  }

  ngOnInit(): void {
    this.statisticItems = this.tenantService.statisticsItems;
    this.getTenantStatistics();

    this.unsubscribe.push(
      this.tenantService.userCount$
        .subscribe((result: boolean) => {
          if (result) {
            this.getTenantStatistics();
          }
        })
    );
  }

  getTenantStatistics() {
    const subscription = this.tenantService.getTenantStatistics()
      .pipe(
        first()
    ).subscribe({
      next: (result: TenantStatisticsModel) => {
        this.statistics = result;
      },
      error: (error: any) => {
        this.toastService.error(`Failed to retrieve customer statistics`);
        this.statistics = undefined;
        throw error;
      }
    });

    this.unsubscribe.push(subscription);
  }

  ngOnDestroy(): void {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  statsButtonClicked(title: any) {
    title = title.replace(/\s/g, "");
    this.logger.trackClick(title)
  }

}
